import { Box, Typography, styled, useMediaQuery } from "@mui/material";
import { motion } from "framer-motion"; // Import Framer Motion
import { useState } from "react"; // Import useState
import { FuelOperations, CardIcon } from "../../constant";

const MainContainer = styled(Box)({
  background: "#000",
  position: "relative",
  width: "100%",
  height: "auto",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "60px 24px",
});

const ImageContainer = styled(Box)({
  width: "100%",
  position: "relative",
  zIndex: 1,
});

const OverlayContainer = styled(Box)({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
});

// Card positions for desktop and tablet
const cardPositions = [
  { top: "6%", left: "68%" },
  { top: "32%", left: "54%" },
  { top: "6%", left: "15.5%" },
  { top: "32%", left: "29.5%" },
];

const tabcardPositions = [
  { top: "12%", left: "67%" },
  { top: "34%", left: "54%" },
  { top: "12%", left: "16.5%" },
  { top: "35%", left: "30.5%" },
];

export default function SeamlessOperations() {
  const isTablet = useMediaQuery("(max-width:1200px)"); // Detect if screen width is below 1200px
  const positions = isTablet ? tabcardPositions : cardPositions; // Use correct positions based on screen size

  const cardData = [
    { title: "Data Aggregation", description: "Real-time alerts for fuel efficiency." },
    { title: "Daily Generated Reports", description: "Monitor speed to ensure safety." },
    { title: "AI-Driven Insights", description: "Detect seat belt usage for compliance." },
    { title: "Automated Dispensing", description: "Track location in real-time." },
  ];

  const [hoverIndex, setHoverIndex] = useState(null); // Track hovered card index

  return (
    <MainContainer>
      <ImageContainer>
        <img
          src={FuelOperations}
          alt="Fuel Operations"
          style={{ width: "100%", height: "auto", display: "block" }}
        />
      </ImageContainer>

      {/* Cards Overlay */}
      <OverlayContainer>
        {cardData.map((card, index) => (
          <motion.div
            key={index}
            onMouseEnter={() => setHoverIndex(index)}
            onMouseLeave={() => setHoverIndex(null)}
            style={{
              position: "absolute",
              top: positions[index].top,
              left: positions[index].left,
              width: isTablet ? "150px" : "270px",
              height: isTablet ? "90px" : "200px",
              padding: isTablet ? "12px" : "30px",
              borderRadius: "14px",
              color: "#fff",
              textAlign: "left",
              overflow: "hidden",
              cursor: "pointer",
              display: "flex",
              flexDirection: "column",
              alignItems: "left",
              justifyContent: "left",
              zIndex: 2,
              background:
                hoverIndex === index
                  ? "linear-gradient(262.41deg, #1DA1F2 -8.32%, #6843EC 93.3%)"
                  : "none",
            }}
          >
            {/* Main Card (Initial State) */}
            <motion.div
              initial={{ y: 0, opacity: 1 }}
              animate={hoverIndex === index ? { y: "-100%", opacity: 0 } : { y: 0, opacity: 1 }}
              transition={{ duration: 0.4, ease: "easeInOut" }}
              style={{
                position: "relative",
                width: "100%",
                borderRadius: "8px",
                textAlign: "left",
              }}
            >
              <img
                src={CardIcon}
                style={{ width: isTablet ? "20px" : "40px", height: isTablet ? "20px" : "40px" }}
                alt="Icon"
              />
              <Typography variant="h5"
              sx={{
                fontSize: { xs: "12px",  md: "16px", lg: "20px" }, 
                fontWeight: 400
              }}
              >{card.title}</Typography>
            </motion.div>

            {/* Slide-Up Info Section */}
            <motion.div
              initial={{ y: "100%", opacity: 0 }}
              animate={hoverIndex === index ? { y: "0%", opacity: 1 } : { y: "100%", opacity: 0 }}
              transition={{ duration: 0.4, ease: "easeInOut" }}
              style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: "100%",
                padding: "16px",
                borderRadius: "14px",
                textAlign: "left",
              }}
            >
              <Typography variant="h5"
              sx={{
                fontSize: { xs: "12px", md: "18px" }, 
                fontWeight: 500
              }}
              >{card.title}</Typography>
              <Typography
              sx={{
                fontSize: { xs: "10px", md: "16px" }, 
                fontWeight: 400
              }}
              >{card.description}</Typography>
            </motion.div>
          </motion.div>
        ))}
      </OverlayContainer>
    </MainContainer>
  );
}
